module.exports = __webpack_public_path__ + "img/JC.d0d297ef.png";